import React from 'react';
import ReactDOM from 'react-dom';
// import TagManager from 'react-gtm-module';
// import ReactGA from 'react-ga4';
import '@src/patches/draftJsImeSelection';
import App from './App';
import 'rc-tooltip/assets/bootstrap.css';
import './index.css';
import 'swiper/swiper-bundle.css';
import 'draft-js/dist/Draft.css';
import * as serviceWorker from './serviceWorker';
import './languages';
// import { GTM_ID } from './configs';

// const tagManagerArgs = {
//   gtmId: GTM_ID,
// };

// TagManager.initialize(tagManagerArgs);
// ReactGA.initialize(GTM_ID);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
